export default "__VITE_ASSET__CKk2CuuP__"